<div class="holder">
  @if (!calculating) {
    <mat-stepper #stepper linear="true"
                 orientation="vertical">
      <mat-step [stepControl]="applicantsCtrl">
        <ng-template matStepLabel>Låntagare</ng-template>
        <div class="stepper-content-holder">
          <spb-test type="APPLICANTS"></spb-test>
          <spb-pers-data (applicantLength)="setApplicantsLength($event)"
                         (validPnr)="setPersonnummer($event)"
                         [applicants]="applicants()"
                         [cars]="cars()"
                         [children]="children()"
                         [validControl]="applicantsCtrl"
                         class="stepper-content"/>
          <spb-help-base section="pers-data"/>
        </div>
        <div class="stepper-buttons">
          <button matButton="filled" matStepperNext="button">Nästa
          </button>
          <div class="spb-filler"></div>
          <button (click)="next()"
                  [disabled]="applicantsCtrl.invalid" matButton="outlined"
          >Beräkna
          </button>
        </div>
      </mat-step>
      <mat-step [stepControl]="incomesCtrl">
        <ng-template matStepLabel>Inkomster/Kostnader</ng-template>
        <div class="stepper-content-holder">
          <spb-test type="INCOMES"></spb-test>
          <spb-income-cost [incomes]="incomes()"
                           [validControl]="incomesCtrl"/>
          <spb-help-base section="income-cost"/>
        </div>
        <div class="stepper-buttons">
          <button class="form-margin" matButton="elevated" matStepperPrevious>
            Tillbaka
          </button>
          <button [disabled]="incomesCtrl.invalid"
                  matButton="filled" matStepperNext="button">Nästa
          </button>
          <div class="spb-filler"></div>
          <button
            (click)="next()"
            [disabled]="incomesCtrl.invalid"
            matButton="outlined"
          >Beräkna
          </button>
        </div>
      </mat-step>
      <mat-step [stepControl]="propertiesCtrl">
        <ng-template matStepLabel>Boende</ng-template>
        <ng-template matStepContent>
          <div class="stepper-content-holder">
            <spb-test type="PROPERTIES"></spb-test>
            <div class="stepper-content">
              <mat-checkbox
                (change)="checkboxChange($event.checked)"
                [checked]="checked"
              >Belåningsobjekt
              </mat-checkbox>
              <spb-new-home
                [properties]="properties()"
                [property]="newProperty"
                [validControl]="propertiesCtrl"
              />
            </div>
            <spb-help-base section="new-home"/>
          </div>
          <div class="stepper-buttons">
            <button class="form-margin" matButton="elevated" matStepperPrevious>
              Tillbaka
            </button>
            <button
              [disabled]="propertiesCtrl.invalid"
              matButton="filled" matStepperNext="button">Nästa
            </button>
            <div class="spb-filler"></div>
            <button
              (click)="next()"
              [disabled]="propertiesCtrl.invalid"
              matButton="outlined"
            >Beräkna
            </button>
          </div>
        </ng-template>
      </mat-step>
      <mat-step [stepControl]="loansCtrl">
        <ng-template matStepLabel>Befintliga lån</ng-template>
        <ng-template matStepContent>
          <div class="stepper-content-holder">
            <spb-test type="LOANS"></spb-test>
            <div class="stepper-content">
              <div>
                <h3>Bolån</h3>
                <spb-loans
                  [borgo]="borgoService.borgoPossible()"
                  [housingLoan]="true"
                  [loans]="loans()"
                  [properties]="properties()"
                  [validControl]="loansCtrl"
                />
              </div>
              <div>
                <h3>{{ borgoService.borgoPossible() ? 'Andra krediter och borgensåtagande' : 'Privatlån, konto- & kortkrediter' }}</h3>
                <spb-loans
                  [borgo]="borgoService.borgoPossible()"
                  [loans]="loans()"
                  [properties]="properties()"
                  [validControl]="loansCtrl"
                />
              </div>
            </div>
            <spb-help-base section="loan"/>
          </div>
          <div class="stepper-buttons">
            <button class="form-margin" matButton="elevated" matStepperPrevious>
              Tillbaka
            </button>
            <div class="spb-filler"></div>
            <button
              (click)="next()"
              matButton="filled" matStepperNext
            >Beräkna
            </button>
          </div>
        </ng-template>
      </mat-step>
    </mat-stepper>
  }
</div>
